import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

import { PermissionDeniedUiService } from '../services/permission-denied-ui.service';
import { extractRbacDeniedMessage, rbac403OmitirUiPerfilOrganizacion, rbac403PreferBannerOnly } from '../utils/rbac-http-error.util';

/** Ante 403 RBAC en zona `/app`, muestra overlay borroso (GET de vista) o banner (acciones / prefetch global). */
export const permissionDeniedInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const ui = inject(PermissionDeniedUiService);

  return next(req).pipe(
    catchError((err: unknown) => {
      if (!(err instanceof HttpErrorResponse)) return throwError(() => err);

      const msg = extractRbacDeniedMessage(err);
      if (!msg) return throwError(() => err);

      const path = router.url.split('?')[0];
      if (!path.startsWith('/app')) return throwError(() => err);

      if (!rbac403OmitirUiPerfilOrganizacion(req)) {
        if (rbac403PreferBannerOnly(req)) {
          ui.showBanner(msg);
        } else {
          ui.showBlockingOverlay(msg);
        }
      }

      return throwError(() => err);
    }),
  );
};
